import * as THREE from "three";

const cache = {};
const loader = new THREE.TextureLoader();

export function tex(path, { srgb = false, repeat = null } = {}) {
  const key = `${path}|${repeat ? repeat.join("x") : ""}`;
  if (cache[key]) return cache[key];
  const t = loader.load(path);
  if (srgb) t.colorSpace = THREE.SRGBColorSpace;
  t.anisotropy = 8;
  if (repeat) {
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    t.repeat.set(repeat[0], repeat[1]);
  }
  cache[key] = t;
  return t;
}

export const surface = (name, repeat = [1, 1]) => ({
  map: tex(`/assets/tex/${name}_diff.jpg`, { srgb: true, repeat }),
  normalMap: tex(`/assets/tex/${name}_nor.jpg`, { repeat }),
});

function billboard(material, sway) {
  material.onBeforeCompile = (shader) => {
    shader.uniforms.uWind = material.userData.wind;
    shader.vertexShader = shader.vertexShader
      .replace("#include <common>", "#include <common>\nuniform float uWind;")
      .replace(
        "#include <project_vertex>",
        `vec3 ip = (modelMatrix * instanceMatrix * vec4(0.0, 0.0, 0.0, 1.0)).xyz;
        float bw = length(instanceMatrix[0].xyz);
        float bh = length(instanceMatrix[1].xyz);
        vec3 tc = cameraPosition - ip; tc.y = 0.0; tc = normalize(tc + vec3(1e-4, 0.0, 0.0));
        vec3 right = vec3(tc.z, 0.0, -tc.x);
        float hh = max(transformed.y, 0.0);
        vec3 wp = ip + right * transformed.x * bw + vec3(0.0, transformed.y * bh, 0.0);
        wp.x += sin(uWind * 1.1 + ip.x * 0.3 + ip.z * 0.2) * ${sway.toFixed(3)} * hh * hh * bh;
        vec4 mvPosition = viewMatrix * vec4(wp, 1.0);
        gl_Position = projectionMatrix * mvPosition;`
      );
  };
  material.customProgramCacheKey = () => `billboard-${sway}`;
  return material;
}

export const SPRITES = {
  oak: 0.686, cypress: 0.146, spruce: 0.557, beech: 0.441, stonepine: 0.791, bush: 1.036, fern: 1.045, dunegrass: 1.01, grasstuft: 1.222, wildflowers: 0.686,
};
const spriteCache = {};
let spriteTint = new THREE.Color("#ffffff");
export function setSpriteTint(color) {
  spriteTint = new THREE.Color(color);
  Object.values(spriteCache).forEach(({ color: m }) => m.color.copy(spriteTint));
}
export const spritePlane = new THREE.PlaneGeometry(1, 1).translate(0, 0.5, 0);

export function spriteMaterials(kind, wind) {
  if (spriteCache[kind]) return spriteCache[kind];
  const map = tex(`/assets/sprites/${kind}.webp`, { srgb: true });
  const sway = SPRITES[kind] > 0.9 ? 0.06 : 0.02;
  const color = new THREE.MeshBasicMaterial({ map, alphaTest: 0.5, side: THREE.DoubleSide, color: spriteTint.clone() });
  const depth = new THREE.MeshDepthMaterial({ depthPacking: THREE.RGBADepthPacking, map, alphaTest: 0.5 });
  [color, depth].forEach((m) => {
    m.userData.wind = wind;
    billboard(m, sway);
  });
  spriteCache[kind] = { color, depth };
  return spriteCache[kind];
}
